import { useState } from "react";
import { cn } from "@/lib/utils";
import gustoAvatar from "@/assets/gusto-avatar.png";

const ChefAvatar = ({ 
  src, 
  name, 
  size = "md",
  showToque = false,
  className,
  toqueClassName,
  onClick
}) => {
  const [imageError, setImageError] = useState(false);
  
  const sizeClasses = {
    xs: "w-6 h-6",
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
    xl: "w-24 h-24",
    "2xl": "w-32 h-32",
  };

  const textSizes = {
    xs: "text-xs",
    sm: "text-sm",
    md: "text-lg",
    lg: "text-2xl",
    xl: "text-4xl",
    "2xl": "text-5xl",
  };

  const initial = name?.charAt(0)?.toUpperCase() || "?";
  const hasImage = src && !imageError;

  return (
    <div 
      className={cn("relative inline-block", className)}
      onClick={onClick}
    >
      <div 
        className={cn(
          "rounded-full bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center text-white font-bold overflow-hidden shadow-lg ring-2 ring-white",
          sizeClasses[size]
        )}
      >
        {hasImage ? (
          <img 
            src={src}
            alt={name || "Avatar"}
            className="w-full h-full object-cover"
            onError={() => setImageError(true)}
          />
        ) : (
          <img 
            src={gustoAvatar}
            alt={name || "Gusto"}
            className="w-[70%] h-[70%] object-contain"
          />
        )}
      </div>
    </div>
  );
};

export default ChefAvatar;
